module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"like_text":"有帮助","unlike_text":"无补","already_submitted":"已选定。请刷新浏览器:)","comment":"回帖"}}')
  delete Component.options._Ctor
}
